import * as mt from './mutation-types';

import { RootState } from '../types';
import { Results } from './types';
import { ActionContext } from 'vuex';
import { ScoreHistogramDTO, AreaHistogramDTO, HarvestResultTableDTO } from '@/api/results/types';

export default {
  [mt.FETCHING_SCORE_HISTOGRAM] ({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCHING_SCORE_HISTOGRAM);
  },
  [mt.FETCH_SCORE_HISTOGRAM_SUCCESS]({ commit }: ActionContext<Results, RootState>, histograms: ScoreHistogramDTO[]) {
    commit(mt.FETCH_SCORE_HISTOGRAM_SUCCESS,  histograms );
  },
  [mt.FETCH_SCORE_HISTOGRAM_FAILED]({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCH_SCORE_HISTOGRAM_FAILED);
  },
  [mt.FETCHING_AREA_HISTOGRAM] ({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCHING_AREA_HISTOGRAM);
  },
  [mt.FETCH_AREA_HISTOGRAM_SUCCESS]({ commit }: ActionContext<Results, RootState>, histograms: AreaHistogramDTO[]) {
    commit(mt.FETCH_AREA_HISTOGRAM_SUCCESS,  histograms );
  },
  [mt.FETCH_AREA_HISTOGRAM_FAILED]({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCH_AREA_HISTOGRAM_FAILED);
  },
  [mt.FETCH_HARVEST_RESULT_REQUEST] ({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCH_HARVEST_RESULT_REQUEST);
  },
  [mt.FETCH_HARVEST_RESULT_SUCCESS]({ commit }: ActionContext<Results, RootState>, dto: HarvestResultTableDTO[]) {
    commit(mt.FETCH_HARVEST_RESULT_SUCCESS,  dto );
  },
  [mt.FETCH_HARVEST_RESULT_FAILED]({ commit }: ActionContext<Results, RootState>) {
    commit(mt.FETCH_HARVEST_RESULT_FAILED);
  },
};
